export enum ZIndex {
  /**
   * To appear over every elements except the Windows Desktop App topbar
   */
  tooltip = '1100',
}
